<template>
    <div class="pricing-plan-cards-section">
        <div class="col-lg-6 col-xs-12 pricing-card-section">
            <div class="pricing-card" @click="$emit('start-family')">
                <h2>Familie</h2>
                <img src="../assets/images/family.png" height="200px">
            </div>
        </div>
        <div class="col-lg-6 col-xs-12 pricing-card-section">
            <div class="pricing-card" @click="$emit('start-care-facility')">
                <h2>Zorginstelling</h2>
                <img src="../assets/images/icon4.svg" height="200px">
            </div>
        </div>
    </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>